import { CURATION_ATOM_KEYS } from './types'
import { atom, selector } from 'recoil'

export const STORE_CURATION = atom<StoreCurationItems[]>({
  key: CURATION_ATOM_KEYS.STORE_CURATION,
  default: [],
})

export const STORE_CURATION_LOADING = atom({
  key: CURATION_ATOM_KEYS.STORE_CURATION_LOADING,
  default: false,
})

export const STORE_CURATION_VISIBLE_SELECTOR = selector({
  key: CURATION_ATOM_KEYS.STORE_CURATION_VISIBLE,
  get: ({ get }) => {
    const curationList = get(STORE_CURATION)

    return curationList.some(({ curationDetailList }) => curationDetailList.length > 0)
  },
})
